import { gql } from '@apollo/client';

export const MY_PERMISSIONS_QUERY = gql`
  query MyPermissions {
    myPermissions {
      permissions {
        menuCode
        permissionBit
      }
    }
  }
`;
